module.exports = __webpack_public_path__ + "img/gPay-merchant-icon.7edd8070.png";